import angular from 'angular';

import { JWT_LOCAL_STORAGE_KEY } from '../components/login/login.service';

export class LocalStorageService {
  constructor(XHRStatsFactory) {
    this._XHRStatsFactory = XHRStatsFactory;
  }

  // Taken from http://crocodillon.com/blog/always-catch-localstorage-security-and-quota-exceeded-errors
  _isQuotaExceeded(e) {
    let quotaExceeded = false;
    if (e) {
      if (e.code) {
        switch (e.code) {
        case 22:
          quotaExceeded = true;
          break;
        case 1014:
          // Firefox
          if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
            quotaExceeded = true;
          }
          break;
        }
      } else if (e.number === -2147024882) {
        // Internet Explorer 8
        quotaExceeded = true;
      }
    }
    return quotaExceeded;
  }

  _description() {
    let storage = []
    let keysLength = 0;
    let valuesLength = 0;
    for (let i = 0; i < localStorage.length; i++) {
      let k = localStorage.key(i);
      let v = localStorage.getItem(k);
      storage.push([k, v.length]);
      keysLength += k.length;
      valuesLength += v.length;
    }
    storage.sort((a,b) => a[1] - b[1]);
    return {
      nkeys: localStorage.length,
      valuesLength: valuesLength,
      keysLength: keysLength,
      sample: storage.slice(-100),
    };
  }

  setItem(key, value) {
    let json_value = angular.toJson(value);
    try {
      localStorage.setItem(key, json_value);
      if (key === JWT_LOCAL_STORAGE_KEY) {
        try {this._XHRStatsFactory.onSetJwtToLocalStorage(json_value);} catch (e) {}
      }
    } catch(e) {
      try {this._XHRStatsFactory.onLocalStorageException('setItem', key, e);} catch (f) {}
      if (this._isQuotaExceeded(e)) {
        // Failed because we exceeded local storage capacity,
        // Clear it and try again (but do save and restore the jwt token so that the user is not redirected to the login page)
        try {this._XHRStatsFactory.onLocalStorageOverflow(this._description());} catch (e) {}
        const jwt = localStorage.getItem(JWT_LOCAL_STORAGE_KEY);
        localStorage.clear();
        localStorage.setItem(JWT_LOCAL_STORAGE_KEY, jwt);
        localStorage.setItem(key, json_value);
        localStorage.setItem('last-ls-clear-on-overquota', angular.toJson(new Date()));
      }
    }
  }

  getItem(key) {
    try {
      let json_value = localStorage.getItem(key);
      return angular.fromJson(json_value);
    } catch (e) {
      try {this._XHRStatsFactory.onLocalStorageException('getItem', key, e);} catch (f) {}
      return null;
    }
  }

  removeItem(key) {
    return localStorage.removeItem(key);
  }

  clear() {
    try {this._XHRStatsFactory.onLocalStorageClear(this._description());} catch (e) {}
    localStorage.clear();
    this.setItem('last-ls-clear', new Date());
  }

  static LocalStorageFactory(XHRStatsFactory) {
    return new LocalStorageService(XHRStatsFactory);
  }

}
LocalStorageService.LocalStorageFactory.$inject = ['XHRStatsFactory'];
